import { render } from "./White.vue?vue&type=template&id=12263058&scoped=true&ts=true"
import script from "./White.vue?vue&type=script&lang=ts"
export * from "./White.vue?vue&type=script&lang=ts"

import "./White.vue?vue&type=style&index=0&id=12263058&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12263058"]])

export default __exports__